export var ShortBreakDTO = {
    'isStartBreak' : null,
    'reason' : null ,
    'breakType' : null
}